<div class="form-login px-4">

  <div *ngIf="(error | async)" class="alert alert-danger" role="alert" @fadeOut>{{ error | async }}</div>

  <button class="btn btn-lg btn-primary btn-block mt-3" (click)="logOut()"><span aria-hidden="true" class="fas fa-sign-out-alt"></span> {{"logout.form.submit" | translate}}</button>
</div>
